import { findOffsetRelativeToScrollParent } from './findOffsetRelativeToScrollParent';
import { findScrollContainer } from './findScrollContainer';

const scrollIntervals: Record<string, number> = {};
/**
 * Busca el padre con scroll visible y establece su scrollTop de acuerdo al offset del elemento pasado como argumento, de modo que éste aparezca visible dentro del padre mencionado.
 *
 * @param fixedOffsetTop Establece un mínimo de distancia que debe mantener con el borde superior del contenedor con scroll. Se usa para compensar en las situaciones donde existen cabezales fijos.
 */
export function scrollParentIntoElement(
  element: HTMLElement,
  fixedOffsetTop = 0,
  tries = 2,
  timeout = 100,
  scrollId: string | undefined = undefined,
) {
  if (scrollId) {
    clearTimeout(scrollIntervals[scrollId]);
  }

  const scrollParent = findScrollContainer(element);
  const offsetTop = findOffsetRelativeToScrollParent(element);

  if (
    scrollParent &&
    (scrollParent.scrollTop + fixedOffsetTop > offsetTop ||
      (scrollParent?.clientHeight ?? Infinity) - fixedOffsetTop <
        element.getBoundingClientRect().height)
  ) {
    scrollParent.scrollTop = offsetTop - fixedOffsetTop;
  } else if (
    scrollParent &&
    scrollParent.scrollTop + scrollParent.clientHeight <
      offsetTop + element.getBoundingClientRect().height
  ) {
    scrollParent.scrollTop = offsetTop;
  }

  if (tries > 0)
    scrollIntervals[scrollId ?? 'noId'] = setTimeout(
      () =>
        scrollParentIntoElement(element, fixedOffsetTop, tries - 1, timeout),
      timeout,
    ) as unknown as number;
}
